import React from "react";
import styled from "styled-components";
import TableBody from "./TableBody";
import {
    useFilters,
    useGlobalFilter,
    usePagination,
    useRowSelect,
    useSortBy,
    useTable,

} from "react-table";

import {configBlueprintTable} from "../../../demoPointEnv/envResultsTable/config/config";
import {BlueprintTopBar} from "./BlueprintTopBar";
import {TopBar} from "./TopBar";
import TableHead from "./TableHead";

const TableWrapper = styled.div`
  border: 1px solid var(--color-table-wrapper);
`;

const Table = styled.table`
  user-select: none;
  border-collapse: collapse;
  overflow-x: auto;
  width: 100%;
  table-layout: fixed;
`;

const HeightWrapper = styled.div`
  height: 450px;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
`;

const BlueprintResultsTable = ({data, filter, setFilter}) => {
    const tableConfig = {
        columns: configBlueprintTable.columns,
        data,
        initialState: {
            height: "50px",
        },
    };

    const tableInstance = useTable(
        tableConfig,
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect
    );
    const {getTableProps} = tableInstance;


    return (
        <div>
            <TableWrapper id={"blueprint-wrapper-table"}>
                <BlueprintTopBar filter={filter} setFilter={setFilter} tableInstance={tableInstance}/>
                <HeightWrapper>
                    <Table {...getTableProps()} id={"blueprint-main-table"}>
                        <TableHead tableInstance={tableInstance}/>
                        <TableBody tableInstance={tableInstance}/>
                    </Table>
                </HeightWrapper>
                <TopBar tableInstance={tableInstance}/>
            </TableWrapper>
        </div>
    );
};

export default BlueprintResultsTable;
